var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyIconDefineTestingStrategy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.781 11.625 9 11v-.75a.703.703 0 0 0-.594-.688L8.25 5.876l.844-.625c.25-.188.406-.5.406-.813V1c0-.531-.469-1-1-1h-7C.937 0 .5.469.5 1v3.438c0 .312.125.625.375.812l.844.625-.157 3.688A.675.675 0 0 0 1 10.25V11l-.813.625A.446.446 0 0 0 0 12v1.5c0 .281.219.5.5.5h9c.25 0 .5-.219.5-.5V12c0-.156-.094-.281-.219-.375zM2 1.5h1.25v1h1v-1h1.5v1h1v-1H8v2.688l-1.281.968.187 4.344H3.063l.187-4.344L2 4.188V1.5zm-.5 11 1-.75V11h5v.75l1 .75h-7zm4.25-6.75A.76.76 0 0 0 5 5a.76.76 0 0 0-.75.75V7h1.5V5.75z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIconDefineTestingStrategy);
export default __webpack_public_path__ + "static/media/survey-icon-define-testing-strategy.346a6bb8ab441647c66ea97e13cd38d8.svg";
export { ForwardRef as ReactComponent };